import React from 'react';
import { LockedWrapper, FeatureImage, TextWrapper, LockedDescription, LockedLink } from './styled';
import FF2FA from 'Images/ff_2fa.png';
import { FormattedMessage } from 'react-intl';
import { URL_PRICING } from 'store/License/actions';

const TwoFactor = () => {
  return (
    <LockedWrapper>
      <FeatureImage src={ FF2FA } />
      <TextWrapper>
        <LockedDescription children={ <FormattedMessage id={ 'upgradeLicense.sidebar.settings.2fa.description' } /> } />
        <LockedLink onClick={ () => window.open(URL_PRICING) } children={ <FormattedMessage id={ 'upgradeLicense.sidebar.settings.2fa.link' } /> } />
      </TextWrapper>
    </LockedWrapper>
  );
};

export default TwoFactor;
